import type { BillingItemType, ParsedBillingItem } from '../types/cartTypes';

export const billingItemsContainsTax = (
  billingItems: ParsedBillingItem[],
): boolean => {
  const taxTypes: BillingItemType[] = ['TAX'];
  return billingItems.some(
    (item) => taxTypes.includes(item.type) && (item.value?.centAmount ?? 0) > 0,
  );
};

export const shouldOrderTotalsRequireAddressID = ({
  subtotal,
  discount,
}): boolean => {
  // For SA, return false when order subtotal (+tax) - discount < 115000
  const orderTotalIDThresholdSA = 115000;
  return subtotal - Math.abs(discount) >= orderTotalIDThresholdSA;
};

// If total line has a non zero value, use that, otherwise sum all the lines
export const getBNPLTotalToUseV2 = (
  billingItems: ParsedBillingItem[],
): number => {
  const totalLine = billingItems.find((detail) => detail.type === 'TOTAL')
    ?.value?.centAmount;
  if (totalLine && totalLine > 0) {
    return totalLine;
  }
  return billingItems.reduce((acc, curr) => {
    const value = curr.value?.centAmount ?? 0;
    return curr.type === 'DISCOUNT' ? acc - value : acc + value;
  }, 0);
};
